export default __webpack_public_path__ + "static/great-intrigue-logo-a1aa9ac884e4d6e9c20b377a204bf1ce.png";